import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent, Fragment } from "react";
import ButtonComponent from "/components/core/button/button-component";
import ClusterOptionComponent from "./cluster-option-component/cluster-option-component";
import LayoutOptionComponent from "/components/segments/cluster-selection/layout-option-component/layout-option-component";
import ClusterSolutionsComponent from "/components/segments/cluster-selection/cluster-solutions-component/cluster-solutions-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import { setCookie } from "/services/cookies-service";
import { CLUSTER_CONFIG_MOBILE, CLUSTER_MOBILE_OPTION_VALUE } from "/services/clusters/clusters-service-mobile";
import { CLUSTER_CONFIG, CLUSTER_OPTION_VALUE } from "/services/clusters/clusters-service";
import { CLUSTER_WITH_SOLUTION_OPTION_VALUE, CLUSTER_WITH_SOLUTION_CONFIG } from "/services/clusters/clusters-with-solutions-service";
import { LAYOUT_CONFIG, LAYOUT_OPTION_VALUE } from "services/clusters/layout-service";
import { scrollTo } from "/services/dom-utils-service";
import { componentStyles } from "./cluster-selection-component.scss";
const STEP2_HASH = "#step2";
class ClusterSelectionComponent extends PureComponent {
    getConfigFromSelection(selection) {
        switch(selection){
            case CLUSTER_OPTION_VALUE:
                return CLUSTER_CONFIG;
            case CLUSTER_WITH_SOLUTION_OPTION_VALUE:
                return CLUSTER_WITH_SOLUTION_CONFIG;
            case LAYOUT_OPTION_VALUE:
                return LAYOUT_CONFIG;
            case CLUSTER_MOBILE_OPTION_VALUE:
                return CLUSTER_CONFIG_MOBILE;
            default:
                return CLUSTER_CONFIG;
        }
    }
    getOptionComponentFromSelection(selection) {
        switch(selection){
            case CLUSTER_OPTION_VALUE:
            case CLUSTER_WITH_SOLUTION_OPTION_VALUE:
            case CLUSTER_MOBILE_OPTION_VALUE:
                return ClusterOptionComponent;
            case LAYOUT_OPTION_VALUE:
                return LayoutOptionComponent;
            default:
                return ClusterOptionComponent;
        }
    }
    componentDidMount() {
        window.onhashchange = this.onBrowserHashChangeEvent;
    }
    onBrowserHashChangeEvent() {
        const hash = window.location.hash;
        if (hash.length === 0) {
            this.setState({
                firstStepCompleted: false
            });
        }
    }
    getSelectedItem() {
        const { selectedId } = this.state;
        const { options } = this._config;
        return options.filter((option)=>option.id === selectedId)[0];
    }
    selectItem(id) {
        const { itemClickedEvent, withoutContinueButton } = this._config;
        BigBrain("track", itemClickedEvent, {
            kind: id
        });
        this.setState({
            selectedId: id
        });
        if (withoutContinueButton) {
            this.nextStep(id);
        } else if (this._nextButton) {
            scrollTo(this._nextButton.offsetTop, 600);
        }
    }
    renderOption(option, singleImage) {
        const { selectedId } = this.state;
        const { selection } = this.props;
        const { withoutContinueButton } = this._config;
        const OptionComponent = this.getOptionComponentFromSelection(selection);
        return /*#__PURE__*/ _jsx(OptionComponent, {
            option: option,
            selected: option.id === selectedId,
            selectCallback: this.selectItem,
            singleImage: singleImage,
            showCheckboxIcon: withoutContinueButton
        }, option.id);
    }
    nextStep(id) {
        let selectedId;
        if (typeof id === "string") {
            selectedId = id;
        }
        selectedId = selectedId || this.state.selectedId;
        let clusterKind = selectedId;
        const { itemSelectedEvent, selectedItemCookieName } = this._config;
        if (!selectedId) {
            clusterKind = "empty";
            selectedId = "other";
        }
        BigBrain("track", itemSelectedEvent, {
            kind: clusterKind
        });
        if (selectedItemCookieName) {
            setCookie(selectedItemCookieName, selectedId);
        }
        if (!window.location.hash) {
            window.location.href = window.location.href + STEP2_HASH;
        }
        this.setState({
            firstStepCompleted: true,
            selectedId
        });
    }
    renderItemSelectionForm() {
        const { options, withoutContinueButton } = this._config;
        return /*#__PURE__*/ _jsxs(Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "cluster-selection-options-wrapper",
                    children: options.map((option)=>this.renderOption(option))
                }),
                !withoutContinueButton && /*#__PURE__*/ _jsx("div", {
                    className: "button-wrapper",
                    ref: (el)=>this._nextButton = el,
                    children: /*#__PURE__*/ _jsx(ButtonComponent, {
                        className: "btn-continue",
                        onClickCallback: this.nextStep,
                        color: "brand-blue",
                        children: "Continue"
                    })
                })
            ]
        });
    }
    renderSecondStep() {
        const { secondStepScreen } = this._config;
        if (secondStepScreen === "Solutions") return this.renderSolutionsScreen();
        return this.renderSelectedItemStep();
    }
    renderSolutionsScreen() {
        const { showDecorations } = this.props;
        const selectedItem = this.getSelectedItem();
        let cta = this._config.ctaText || "Create your account";
        return /*#__PURE__*/ _jsx("div", {
            className: "cluster-solutions-wrapper",
            children: /*#__PURE__*/ _jsx(ClusterSolutionsComponent, {
                showDecorations: showDecorations,
                selectedCluster: selectedItem,
                cta: cta
            })
        });
    }
    renderSelectedItemStep() {
        const { showDecorations } = this.props;
        let cta = this._config.ctaText || "Create your account";
        return /*#__PURE__*/ _jsxs(Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "selected-cluster-wrapper",
                    children: [
                        " ",
                        this.renderOption(this.getSelectedItem(), true)
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "button-wrapper-signup",
                    children: /*#__PURE__*/ _jsx(SignupFormComponent, {
                        buttonColor: "brand-blue",
                        ctaText: cta,
                        showDecorations: showDecorations
                    })
                })
            ]
        });
    }
    getTitleHtml() {
        const { firstStepCompleted } = this.state;
        const { firstStepHtmlTitle, secondStepHtmlTitle, otherDetailsHtmlTitle } = this._config;
        if (!firstStepCompleted) return firstStepHtmlTitle;
        const selectedItem = this.getSelectedItem();
        if (selectedItem.secondStepHtmlTitle) return selectedItem.secondStepHtmlTitle;
        return selectedItem.isOther ? otherDetailsHtmlTitle : secondStepHtmlTitle;
    }
    getSubtitleHtml() {
        const { subtitleHtml, secondStepSubtitleHtml } = this._config;
        const { firstStepCompleted } = this.state;
        if (firstStepCompleted) return secondStepSubtitleHtml;
        return subtitleHtml;
    }
    render() {
        const { firstStepCompleted } = this.state;
        const titleHtml = this.getTitleHtml();
        const subTitleHtml = this.getSubtitleHtml();
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + "cluster-selection-wrapper",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "form-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            dangerouslySetInnerHTML: {
                                __html: titleHtml
                            },
                            className: `jsx-${componentStyles.__hash}` + " " + "manage-title"
                        }),
                        subTitleHtml && /*#__PURE__*/ _jsx("div", {
                            dangerouslySetInnerHTML: {
                                __html: subTitleHtml
                            },
                            className: `jsx-${componentStyles.__hash}` + " " + "manage-subtitle"
                        }),
                        firstStepCompleted ? this.renderSecondStep() : this.renderItemSelectionForm()
                    ]
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.nextStep = this.nextStep.bind(this);
        this.renderOption = this.renderOption.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.onBrowserHashChangeEvent = this.onBrowserHashChangeEvent.bind(this);
        this.renderItemSelectionForm = this.renderItemSelectionForm.bind(this);
        this.renderSecondStep = this.renderSecondStep.bind(this);
        this._nextButton = null;
        this._config = this.getConfigFromSelection(props.selection);
        this.state = {
            selectedId: null,
            firstStepCompleted: false
        };
    }
}
export { ClusterSelectionComponent as default };
